/*
__/\\\\\\\\\\\\\\\__/\\\\\\\\\\\\\\\_____/\\\\\\\\\____        
 _\///////\\\/////__\///////\\\/////____/\\\\\\\\\\\\\__       
  _______\/\\\_____________\/\\\________/\\\/////////\\\_      
   _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_     
    _______\/\\\_____________\/\\\_______\/\\\\\\\\\\\\\\\_    
     _______\/\\\_____________\/\\\_______\/\\\/////////\\\_   
      _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_  
       _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_ 
        _______\///______________\///________\///________\///__
            
            COPYRIGHT TACTICAL TRANSPORTATION ADVISORS, INC. 
            ALL RIGHTS RESERVED.
*/

import moment from "moment";
import { useEffect, useState } from "react";
import Cookies from "universal-cookie";

export function useStateWithCookies(key, defaultValue) {
  const cookies = new Cookies();
  const [value, setValue] = useState(cookies.get(key) ?? defaultValue);

  function handleSetValue(newValue) {
    const expireDate = moment().add(1, "year").toDate();
    cookies.set(key, newValue, {
      path: "/",
      expires: expireDate,
    });
    setValue(newValue);
  }

  useEffect(() => {
    if (cookies.get(key) !== undefined) {
      return;
    }

    const isEqual = Array.isArray(value) && Array.isArray(defaultValue) ? value.length === defaultValue.length && value.every((v, i) => v === defaultValue[i]) : value === defaultValue;

    if (!isEqual) {
      setValue(defaultValue);
    }
  }, [defaultValue]);

  return [value, handleSetValue];
}
